export default __webpack_public_path__ + "static/media/Hair_15_F_C4.76ece67b.svg";